const primaryColor = '#303D54'
const secondaryColor = '#1678c2'
const errorColor = 'red'

export { primaryColor, secondaryColor, errorColor }
